import React, { useState, useEffect, useRef, Fragment } from 'react';
import { Nav, InputGroup, Form, Col } from 'react-bootstrap';
import Input from '../utils/Input';
import axiosInstance from '../utils/axios';
import StyledSearchBar from '../../styles/StyledSearchBar'
import { useHistory } from 'react-router-dom';



const SearchBar = () => {
    const [display, setDisplay] = useState(false);
    const [setActive, setActiveState] = useState('');
    const [setWidth, setWidthState] = useState('0px')
    const [options, setOptions] = useState([]);
    const [search, setSearch] = useState('');
    const content = useRef(null);
    const wrapperRef = useRef(null);
    const history = useHistory();

    useEffect(() => {
        const fetchMovieData = async () => {

            const res = await axiosInstance
                .get('/movies')
                .then(res => {
                    setOptions(res.data);
                })
                .catch(err => console.log(err))
            return res;
        }

        fetchMovieData();

    }, []);

    const handleChange = event => {
        setSearch(event.target.value);
        setDisplay(true);
        if (event.target.value.length === 0) {
            setDisplay(false)
        }
    }

    const handleClickOutside = event => {
        const { current: wrap } = wrapperRef;
        if (wrap && !wrap.contains(event.target)) {
            setDisplay(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside)

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, []);

    const handleClick = (movie) => {
        const movieTitle = movie.title.replace(/[\s+]/g, '-').replace(/[,:'.#]/g, '').replace(/[&]/g, 'and');
        const movieId = movie.id;
        history.push(`/movie-profile/${movieId}/${movieTitle}`)
        setDisplay(false);
        setSearch('');
    }

    function toggleAccordion() {
        setActiveState(setActive === '' ? 'active' : '');
        setWidthState(setActive === 'active' ? '0px' : `${content.current.scrollWidth}px`);
    }


    return (
        <Fragment>
            <StyledSearchBar ref={wrapperRef} className='accordion__section'>
                <Nav.Link className={`accordion ${setActive}`} onClick={toggleAccordion}>
                    {setActive === 'active' ? null :
                        <i className="fas fa-search accordion__title"></i>
                    }
                </Nav.Link>

                <div ref={content} style={{ width: `${setWidth}` }} className='accordion__content'>
                    <Form.Group as={Col} mb={0} className="form-group-content">
                        <InputGroup>
                            <InputGroup.Prepend>
                                <InputGroup.Text id='inputGroupPrepend'><i className="fas fa-search"></i></InputGroup.Text>
                                <Input
                                    results='0'
                                    id='search'
                                    inputtype='search'
                                    name='search'
                                    className='search'
                                    placeholder="Search movie titles..."
                                    value={search}
                                    onChange={handleChange}
                                />
                                <Nav.Link className='underline close-btn' onClick={toggleAccordion}>
                                    <i className="fas fa-times"></i>
                                </Nav.Link>
                            </InputGroup.Prepend>
                        </InputGroup>
                    </Form.Group>
                    {display && (
                        <div className='searchContainer' id='search-style'>
                            {
                            options
                                .filter(value => {
                                    const movie = value.title.toLowerCase();
                                    if (movie.indexOf(search.toLowerCase()) !== -1) {
                                        return movie;
                                    }})
                                .map(value => {
                                    return (
                                        <div className='option' key={value.id} onClick={() => handleClick(value)} >
                                            <span>{value.title}</span>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    )}

                </div>
            </StyledSearchBar>
        </Fragment>
    )
};

export default SearchBar;